import SummaryCards from "../components/SummaryCards";
import QueueSection from "../components/QueueSection";
import MissedCalls from "../components/MissedCalls";
import History from "../components/History";
import "./dashbord.css";
import { useState } from "react";
import { useEffect } from "react";
export default function Dashboard() {
    return (
        <div className="dashboard-page">
            <h1>📡 Centrex – Dashboard temps réel</h1>

            <SummaryCards />

            <div className="dashboard-grid">
                <QueueSection />
                <MissedCalls />
            </div>
        </div>
    );
}